import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { ICreateSchedulePayload } from 'src/interfaces/Schedule';
import { lang, queryKeys, requestCCApi } from 'src/utils';

export const useCreateSchedule = () => {
  return useMutation({
    mutationFn: createSchedule,
    onSuccess: async (_, variable) => {
      await queryClient.refetchQueries(queryKeys.components.invalidateAll());
      await queryClient.refetchQueries(
        queryKeys.componentListing.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.scheduleOverview.invalidateAll());
      // clear cache of calendar endpoint under the updated location group
      queryClient.invalidateQueries(
        queryKeys.getCalendarEvents.details([
          String(variable.location_group_id),
        ]),
      );
      queryClient.invalidateQueries(queryKeys.schedules.invalidateAll());
    },
  });
};

async function createSchedule(
  payload: ICreateSchedulePayload,
): Promise<{ id: number }> {
  const response = await requestCCApi(
    {
      url: '/schedules',
      method: 'POST',
      data: {
        data: payload,
      },
    },
    true,
    lang.publishFailed,
  );

  return response;
}
